export default {
  baseUrl: 'https://zgm.v-trend.cn/api',
  imgUrl: "https://zgm.v-trend.cn",
  header: {
    'Content-Type': 'application/x-www-form-urlencoded',
    "XX-Token": localStorage.getItem("token"),
    "XX-Device-Type": "wxapp"
  },
}